// Module
var code = `<span class="spg-color-editor__color-swatch" data-bind="style: getSwatchStyle()"></span>
<!-- ko template: { name: 'survey-string', data: item.locTitle } --><!-- /ko -->`;
// Exports
export default code;